import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { isInteger } from 'lodash';
import { COLORS } from 'Components/utils/color/colors';
import { themes } from './ProgressBar.themes';
type Props = {
  className?: string;
  color?: Colors;
  max?: number;
  min?: number;
  theme?: keyof typeof themes;
  value: number;
};
export const ProgressBar = ({
  className,
  color = COLORS.SAFFRON,
  min = 0,
  max = 10,
  theme = 'default',
  value,
}: Props) => {
  if (!isInteger(value) || value < 0) {
    return null;
  }

  const stepPercent = 100 / (max - min);
  const currentPercent = stepPercent * (value - min);
  const { thBar, thRoot } = themes[theme];
  return (
    <div
      aria-valuemax={max}
      aria-valuemin={min}
      aria-valuenow={value}
      className={classnames(thRoot, className)}
      role="progressbar"
    >
      <div
        className={classnames(thBar, `bg-${color}`)}
        data-testid="progress-bar"
        style={{
          width: `${currentPercent}%`,
        }}
      />
    </div>
  );
};
